import styled from 'styled-components'

export const Background = styled.div`
    position: fixed;
    top: 0;
    left: 0;

    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .85);
    z-index: 999999;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    
`

export const Label = styled.div`
    color: #FFFFFF;
    font-size: 25px;
    
`